import React from "react";
interface Props {
  devices: any;
  deviceUId: string | null;
  deviceId: number | null | 0;
}
const useFindDevice = (devices: any, deviceUId: string | null) => {
  const device = devices.find(
    (device: any) => device.deviceUId && device.deviceUId == deviceUId
  );
  return device || null;
};

export default useFindDevice;
